import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output} from '@angular/core';
import { ReplaySubject} from "rxjs";
import {Employee, LeaveOfAbsence} from "../../../../shared/interface/employee";
import {User} from "../../../../shared/interface/user";
import {AuthService} from "../../../../shared/services/auth.service";
import {MatDialog} from "@angular/material/dialog";
import {LicensedAgentService} from "../../../../shared/services/licensed-agent.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {DictService, FILE_TYPE_KRK} from "../../../../shared/services/dict.service";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {co} from "@fullcalendar/core/internal-common";
import {DocumentAddDialogComponent} from "../../../documents/document-add-dialog/document-add-dialog.component";
import {
  LeaveApplicationAddDialogComponent
} from "../../leave/leave-application-add-dialog/leave-application-add-dialog.component";

@Component({
  selector: 'app-employee-details-view',
  templateUrl: './employee-details-view.component.html',
  styleUrls: ['./employee-details-view.component.scss']
})
export class EmployeeDetailsViewComponent implements OnInit, OnDestroy, OnChanges {
  @Input() employee: Employee;
  @Input() user: User;
  @Output() modifyClicked = new EventEmitter<any>();

  userPermissions: ReplaySubject<UserPermissions>;

  currentLeave: LeaveOfAbsence;
  lastLeave: LeaveOfAbsence;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);


  constructor(
    private auth: AuthService,
    private dialog: MatDialog,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    if (this.employee && this.employee.leaveOfAbsence) {
      this.currentLeave = this.employee.leaveOfAbsence.find(
        x => x.year === new Date().getFullYear().toString()
      );
      this.lastLeave = this.employee.leaveOfAbsence.find(
        x => x.year === (new Date().getFullYear() - 1).toString()
      );
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  addLeaveApplication(): void {
    const dialogRef = this.dialog.open(LeaveApplicationAddDialogComponent, {
      width: '55%',
      data: {
        leaveOfAbsence: this.currentLeave,
        workingHours: this.employee.workingHours,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  modify(): void {
    this.modifyClicked.emit();
  }

}
